import axios from "@/util/axios";

const PREFIX_URI = "/basedata/product/grant/staff";

export default {
    /** 分页查询授权配置列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 查询授权详情（含数据明细） */
    findById: (id) => axios.get({url: `${PREFIX_URI}/findById`, data: {id}}),
    /** 分页查询某职员的授权结果 */
    queryGrantResult: (data) => axios.get({url: `${PREFIX_URI}/queryGrantResult`, data}),
    /** 保存授权 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 取消授权 */
    cancel: (id) => axios.del({url: `${PREFIX_URI}/cancel`, data: {id}}),
    /** 单独删除授权结果中的某一条数据 */
    deleteResult: (id) => axios.del({url: `${PREFIX_URI}/deleteResult`, data: {id}}),
}
